import { publisherConstants } from "../constants";


export function publisher(state = { loading: false, pinnedLoading: false }, action) {
    switch (action.type) {
        case publisherConstants.GET_REQUEST:
            return {
                ...state,
                loading: true
            };
        case publisherConstants.GET_SUCCESS:
            return {
                ...state,
                publisherList: action.payload,
                loading: false
            };
        case publisherConstants.GET_FAILURE:
            // console.log(action.payload)
            return {
                ...state,
                error: action.payload,
                publisherList: "",
                loading: false,
                done: true
            };
        case publisherConstants.GET_FAILURE_DONE:
            return {
                ...state,
                error: Object.keys({ ...state.error }).length === 0 ? "" : { ...state.error },
                publisherList: "",
                loading: false,
                done: false
            };
        // Pinned-publishers fetch is tracked separately from the block above
        // (own request/success/failure types) so pinnedPublisherList is only
        // ever replaced on GET_MY_SUCCESS, never cleared just because a fetch
        // started - same pattern as newspin.reducer.js's savedNewsList, which
        // lets the Pinned Publishers view keep showing what it already has
        // while a refetch is in flight instead of flashing a spinner.
        case publisherConstants.GET_MY_REQUEST:
            return {
                ...state,
                pinnedLoading: true
            };
        case publisherConstants.GET_MY_SUCCESS:
            return {
                ...state,
                pinnedPublisherList: action.payload,
                pinnedLoading: false
            };
        case publisherConstants.GET_MY_FAILURE:
            return {
                ...state,
                pinnedError: action.payload,
                pinnedLoading: false
            };
        default:
            // console.log("in default")
            // console.log(state)
            return state;
    }
}